<!-- user-registration-step2.component.html -->
<div class="modal-overlay"
      [ngClass]="darkMode ? 'bg-kia-dark-mode' : 'bg-kia-light-mode'"
      style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 1050; display: flex; align-items: center; justify-content: center;">
    <div class="modal-content border-0 shadow" style="max-width: 500px; width: 90%;">
      <div class="text-center pt-4 px-4">
        <img src="../../../../../assets/media/logos/new_kia_logo.png" alt="KIA Logo" class="img-fluid mb-3" style="width: 200px;">
        <h4 class="modal-title pt-10">{{title}}</h4>
      </div>

      <div class="modal-body px-4 py-3 ">
        <form [formGroup]="detailsForm">
          <div class="form-group mb-3">
            <label for="firstNameInput">First name</label>
            <input
              type="text"
              class="form-control"
              id="firstNameInput"
              formControlName="firstName"
              placeholder="Enter your first name"
              [ngClass]="{'is-invalid': detailsForm.get('firstName')?.invalid && (detailsForm.get('firstName')?.dirty || detailsForm.get('firstName')?.touched)}"
            >
            <div class="invalid-feedback" *ngIf="detailsForm.get('firstName')?.errors?.['required'] && (detailsForm.get('firstName')?.dirty || detailsForm.get('firstName')?.touched)">
                First name is required.
            </div>
            <div class="invalid-feedback" *ngIf="detailsForm.get('firstName')?.errors?.['minlength'] && (detailsForm.get('firstName')?.dirty || detailsForm.get('firstName')?.touched)">
                First name must be at least 3 characters.
            </div>
          </div>

          <div class="form-group mb-3">
            <label for="lastNameInput">Last name</label>
            <input
              type="text"
              class="form-control"
              id="lastNameInput"
              formControlName="lastName"
              placeholder="Enter your last name"
              [ngClass]="{'is-invalid': detailsForm.get('lastName')?.invalid && (detailsForm.get('lastName')?.dirty || detailsForm.get('lastName')?.touched)}"
            >
            <div class="invalid-feedback" *ngIf="detailsForm.get('lastName')?.errors?.['required'] && (detailsForm.get('lastName')?.dirty || detailsForm.get('lastName')?.touched)">
              Last name is required.
            </div>
            <div class="invalid-feedback" *ngIf="detailsForm.get('lastName')?.errors?.['minlength'] && (detailsForm.get('lastName')?.dirty || detailsForm.get('lastName')?.touched)">
                Last name must be at least 3 characters.
            </div>
          </div>

          <div class="form-group mb-3">
            <label for="countrySelect">Dealership site</label>
            <app-site-select
              [sites]="sites"
              [selectedSite]="selectedSite"
              (siteChange)="onSiteChange($event)"
            ></app-site-select>

            <div class="invalid-feedback" *ngIf="detailsForm.get('site')?.errors?.['required'] && (detailsForm.get('site')?.dirty || detailsForm.get('site')?.touched)">
                Country is required.
            </div>
          </div>

          <div class="info-note alert alert-info">
            <small>
              <strong>Note:</strong> We use these details to ensure we deliver the best experience to you, tracking your progress, enabling quizzes, and more.
            </small>
          </div>
        </form>
      </div>

      <div class="modal-footer justify-content-center border-top-0 px-4 pb-4">
        <button
          type="button"
          class="btn btn-primary"
          style="background-color: #1EAAED; border: none;"
          [disabled]="detailsForm.invalid || isSubmitting"
          (click)="submitDetails()"
        >
          <span *ngIf="!isSubmitting" class="indicator-label">Start training</span>
          <span *ngIf="isSubmitting">
            Please wait...
            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        </button>
      </div>
    </div>
  </div>